import React from "react";
import { Outlet } from "react-router-dom";

function MainProformaInvoice() {
  return (
    <div className="h-full w-full">
      <Outlet />
    </div>
  );
}

export default MainProformaInvoice;
